import { all, takeEvery, takeLatest } from 'redux-saga/effects';
import { ISO_DATE_FORMAT, ENDPOINTS } from 'utils';
import moment from 'moment';
import { requestSagaFactory } from 'helpers';
import { ITEMS_PER_PAGE_SIZE } from 'modules/admin-panel/utils';
import {
	IEmployees,
	IResponseRoundList,
	ISearchWithPagination,
} from '../models';
import {
	getShortClientList,
	getEmployeeList,
	getSurveyRoundList,
	updateDashboardClientList,
} from '../results.actions';
import * as types from '../ActionTypes';

const getSurveyRoundListSaga = requestSagaFactory<
	ISearchWithPagination,
	IResponseRoundList
>({
	url: ENDPOINTS.resultSurveyRoundList,
	actionApi: getSurveyRoundList,
	logErrorMessage: 'get survey round list',
	parsePayload: (payload: ISearchWithPagination) => ({
		...payload,
		startDate: moment(payload.startDate).format(ISO_DATE_FORMAT),
		endDate: moment(payload.endDate).format(ISO_DATE_FORMAT),
		size: payload.size ?? ITEMS_PER_PAGE_SIZE,
	}),
});

const getEmployeeListSaga = requestSagaFactory({
	url: ENDPOINTS.resultEmployeeList,
	actionApi: getEmployeeList,
	logErrorMessage: 'get employees',
	parsePayload: (payload: IEmployees) => ({
		...payload,
		startDate: moment(payload?.startDate).format(ISO_DATE_FORMAT),
		endDate: moment(payload?.endDate).format(ISO_DATE_FORMAT),
		northeastLatitude: -180,
		northeastLongitude: -90,
		southwestLatitude: 180,
		southwestLongitude: 90,
	}),
});

const getShortClientListSaga = requestSagaFactory({
	url: ENDPOINTS.shortClients,
	actionApi: getShortClientList,
	logErrorMessage: 'get dashboard client list',
});

const updateDashboardClientListSaga = requestSagaFactory({
	url: ENDPOINTS.shortClients,
	actionApi: updateDashboardClientList,
	logErrorMessage: 'update dashboard client list',
});

export function* resultsSaga() {
	yield all([
		takeLatest(types.GET_SURVEY_ROUND_LIST.DEFAULT, getSurveyRoundListSaga),
		takeLatest(types.GET_EMPLOYEE_LIST.DEFAULT, getEmployeeListSaga),
		takeLatest(types.GET_SHORT_CLIENT_LIST.DEFAULT, getShortClientListSaga),
		takeEvery(
			types.UPDATE_DASHBOARD_CLIENT_LIST.DEFAULT,
			updateDashboardClientListSaga,
		),
	]);
}
